<template>
  <div class="job-component">
    <b-row align-v="end" class="mb-4 g-1" no-gutters>
      <b-col cols="12">
        <h4 v-html="jobsTitle"></h4>
      </b-col>
      <b-col cols="auto">
        <b-button @click="toProfessions()" variant="primary" size="sm" class="position-relative z-3" v-b-tooltip.hover :title="translations[13756]">
          <b-icon icon="chevron-left"></b-icon>
          <span class="ml-1 d-none d-md-inline-block">{{ translations[2901] }}</span>
        </b-button>
      </b-col>
      <b-col cols="auto">
        <b-button v-if="$route.name === 'Home'" size="sm" variant="primary" class="position-relative z-3" v-b-toggle.jobs-filter>
          <span v-b-tooltip.hover :title="translations[13590]">
            <b-icon icon="sliders"></b-icon>
            <span class="ml-1 d-none d-md-inline-block">{{ translations[13590] }}</span>
          </span>
        </b-button>
        <b-button v-if="$route.name === 'Map'" size="sm" variant="primary" class="position-relative z-3" v-b-toggle.map-filter>
          <span v-b-tooltip.hover :title="translations[13590]">
            <b-icon icon="sliders"></b-icon>
            <span class="ml-1 d-none d-md-inline-block">{{ translations[13590] }}</span>
          </span>
        </b-button>
      </b-col>
      <b-col v-if="isSortingVisible" cols="auto">
        <b-select size="sm" v-model="dateSort" @change="jobsLoading">
          <b-select-option :value="0">{{ translations[11486] }}</b-select-option>
          <b-select-option :value="4">{{ translations[11487] }}</b-select-option>
        </b-select>
      </b-col>
      <b-col cols="auto" class="ml-auto">
        <b-button variant="primary" size="sm" class="position-relative z-3" v-b-modal="!isAuth ? 'not-auth-modal' : ''">
          <b-icon icon="envelope"></b-icon>
          <span class="ml-1 d-none d-md-inline-block">
            {{ translations[10473] }}
          </span>
          <b-icon v-if="!isAuth" icon="shield-lock" class="ml-1"></b-icon>
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mb-3" no-gutters>
      <b-col></b-col>
      <b-col cols="auto" class="d-flex align-items-center">
        <b-dropdown variant="primary" size="sm" class="rounded-0 rounded-start mr-1">
          <template v-slot:button-content>
            {{ paginationPerPage }}
          </template>
          <b-dropdown-item @click="[(paginationPerPage = 20), jobsLoading()]">20</b-dropdown-item>
          <b-dropdown-item @click="[(paginationPerPage = 50), jobsLoading()]">50</b-dropdown-item>
          <b-dropdown-item @click="[(paginationPerPage = 100), jobsLoading()]">100</b-dropdown-item>
        </b-dropdown>
        <b-pagination class="mb-0" size="sm" v-model="paginationPage" :total-rows="count" :per-page="paginationPerPage" @change="jobsLoading" />
      </b-col>
    </b-row>
    <b-overlay :show="loading" rounded="sm" variant="primary" :opacity="0.2" style="min-height: 200px">
      <template v-if="jobs?.length || loading">
        <job-item
          v-for="(item, index) in jobs"
          :key="index"
          :count="countNumber(index + 1)"
          :date="item[0]"
          :id="item[1]"
          :title="item[2]"
          :description="item[3]"
          :description-city="item[4]"
          :letter="item[5]"
          :shortview="item[7]"
          :contact="item[8]"
          :update="item[9]"
          :translate-job="item[10]"
          :is-auth="isAuth"
          :active="isNotebookItem(item[1]).length"
        />
      </template>
      <h5 v-else class="text-center">{{ translations[13786] }}</h5>
    </b-overlay>
    <b-row class="mt-3" no-gutters>
      <b-col></b-col>
      <b-col cols="auto" class="d-flex align-items-center">
        <b-dropdown variant="primary" size="sm" class="rounded-0 rounded-start mr-1">
          <template v-slot:button-content>
            {{ paginationPerPage }}
          </template>
          <b-dropdown-item @click="[(paginationPerPage = 20), jobsLoading()]">20</b-dropdown-item>
          <b-dropdown-item @click="[(paginationPerPage = 50), jobsLoading()]">50</b-dropdown-item>
          <b-dropdown-item @click="[(paginationPerPage = 100), jobsLoading()]">100</b-dropdown-item>
        </b-dropdown>
        <b-pagination class="mb-0" size="sm" v-model="paginationPage" :total-rows="count" :per-page="paginationPerPage" @change="jobsLoading" />
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import { ProfessionModule } from '@/store/modules/profession';
import JobItem from '@/components/Home/JobItem.vue';
import { JobType } from '@/types/ProfessionType';
// eslint-disable-next-line import/named
import { NotebookModule } from '@/store/modules/notebook';
import { MapModule } from '@/store/modules/map';

@Component({
  components: {
    JobItem,
  },
})
export default class JobComponent extends Vue {
  get translations() {
    return AppModule.translation;
  }

  loading = false;

  get jobsTitle() {
    if (this.jobType === JobType.search || this.jobType === JobType.map) {
      if (this.selectProfession || this.selectLocation) {
        return `${this.count || 0} ${this.count === 1 ? this.translations[13772] : this.translations[13773]} ${this.selectProfession?.name || ''}${
          (this.selectProfession?.name && this.selectLocation?.name) ? ',' : ''
        } ${this.selectLocation?.name || ''}`;
      }
      return `${this.count || 0} ${this.count === 1 ? this.translations[13785] : this.translations[13774]}`;
    }
    return `${this.count || 0} ${this.count === 1 ? this.translations[13772] : this.translations[13773]} ${this.professionTitle}`;
  }

  get jobs() {
    return ProfessionModule.jobs.jobs;
  }

  get jobType() {
    return ProfessionModule.jobType;
  }

  get isJobCluster() {
    return this.jobType === JobType.cluster;
  }

  get count() {
    return ProfessionModule.jobs.amt;
  }

  get languageSid() {
    return AppModule.languageSid;
  }

  get isAuth() {
    return UserModule.isUserAuth;
  }

  // search professions
  get selectProfession() {
    return ProfessionModule.searchJobProfession;
  }

  get selectLocation() {
    return ProfessionModule.searchJobLocation;
  }

  get professionTitle() {
    return ProfessionModule.professionTitle;
  }

  get jobsMapIds() {
    return MapModule.selectedRegionJobsIds;
  }

  // pagination
  get paginationPage(): number {
    return ProfessionModule.jobPagination.page;
  }

  set paginationPage(val) {
    ProfessionModule.SetPagination({ obj: 'page', value: val });
  }

  get paginationPerPage(): number {
    return ProfessionModule.jobPagination.per_page;
  }

  set paginationPerPage(val) {
    ProfessionModule.SetPagination({ obj: 'per_page', value: val });
  }

  get notebookJobs() {
    return NotebookModule.notebookJobs;
  }

  // END pagination
  // Sort
  get isSortingVisible() {
    return this.jobType === JobType.search && this.selectProfession?.name && this.selectLocation?.name;
  }

  get dateSort():string {
    return ProfessionModule.jobSort.sort;
  }

  set dateSort(val) {
    ProfessionModule.SetSort({ obj: 'sort', value: val });
  }
  // END Sort

  countNumber(count: number) {
    return (this.paginationPage - 1) * this.paginationPerPage + count;
  }

  isNotebookItem(value: number) {
    return this.notebookJobs.filter((x: { id: number }) => x.id === value);
  }

  async loadJobListItems() {
    this.loading = true;
    await ProfessionModule.GetJobs({
      sid: this.languageSid,
    });
    this.loading = false;
  }

  async loadJobListItemsSearch() {
    this.loading = true;
    await ProfessionModule.GetJobsSearch({
      sid: this.languageSid,
    });
    this.loading = false;
  }

  async loadJobListItemsMap() {
    this.loading = true;
    await ProfessionModule.GetJobsMap({
      params: { sid: this.languageSid },
      ids: this.jobsMapIds,
    });
    this.loading = false;
  }

  jobsLoading() {
    this.$nextTick(() => {
      if (this.jobType === JobType.search) {
        this.loadJobListItemsSearch();
      } else if (this.jobType === JobType.map) {
        this.loadJobListItemsMap();
      } else if (this.jobType === JobType.items) {
        this.loadJobListItems();
      }
    });
  }

  toProfessions() {
    if (this.jobType === JobType.map) {
      AppModule.SetVisibleMap(true);
      AppModule.SetVisibleJobs(false);
    } else {
      AppModule.SetVisibleJobs(false);
    }
  }

  created() {
    ProfessionModule.SetSort({ obj: 'sort', value: 0 });
    this.jobsLoading();
  }
}
</script>
<style scoped lang="scss"></style>
